:host {
  display: inline-block;
  width: auto;
  height: auto;
}

.filter {
  &--content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-height: var(--enum-filter-content-max-height);
    overflow: hidden;
  }

  &--footer {
    padding: var(--spacer);
    border-top: 1px solid var(--chart-100-pressed);
    display: flex;
    justify-content: space-between;
    background: var(--white-layout-301-level-0-elevation);

    &.hidden {
      display: none;
    }
  }
}

:host([disabled]) {
  pointer-events: none;
  opacity: 0.6;
}

.spinner {
  display: flex;
  justify-content: center;
  padding: var(--spacer) calc(var(--spacer) * 2) var(--spacer) var(--spacer);

  gz-progress-spinner {
    width: fit-content;
    display: flex;
    transform: scale(1.5);
  }
}

:host([isLoading]) {
  .dropdown-list {
    &--inner {
      overflow: hidden;
    }
  }
}

.dropdown-error {
  display: flex;
  padding: var(--spacer);
  color: var(--red-layout-300-primary);
  overflow: auto;
  line-height: var(--body-size);
}
